module.exports = __webpack_public_path__ + "img/main.6594c7c4.jpg";